export default __webpack_public_path__ + "static/media/CynthiaUgwu.ebcaaedd.svg";